export default __webpack_public_path__ + "static/media/tooltip.8e99d241.svg";